package com.ijoin.i18n

/**
 * English strings implementation
 */
object EnglishStrings : Strings {
    override val appName = "iJoin"
    override val clickMe = "Click me!"
    override val greetingMessage = "Compose"
    override fun helloPlatform(platformName: String) = "Hello, $platformName!"
    override val language = "Language"
    override val english = "English"
    override val russian = "Russian"
    override val changeLanguage = "Change Language"
    override val ok = "OK"
    override val cancel = "Cancel"
    override val save = "Save"
    override val delete = "Delete"
    override val edit = "Edit"
    override val close = "Close"
    override val retry = "Try again"
    override val share = "Share"
    override val unknownErrorMessage = "Something went wrong. Please try again."
    override val missingEventDateError = "Event date is missing."
    override val slotSelectionRequired = "Select at least one slot."
    override val userContextMissingError = "Couldn't identify the current user."
    override val cancelSlotsSelectionRequired = "Select at least one slot to cancel."
    override val cancelDaySelectionRequired = "Select a day to cancel."
    override val restoreSlotsSelectionRequired = "Select at least one slot to restore."
    override val restoreDaySelectionRequired = "Select a day to restore."
    override val cancelSlotsFailed = "Unable to cancel selected slots."
    override val cancelDayFailed = "Unable to cancel the selected day."
    override val restoreSlotsFailed = "Unable to restore selected slots."
    override val restoreDayFailed = "Unable to restore the selected day."
    override val cancelEventFailed = "Unable to cancel the event."
    override val restoreEventFailed = "Unable to restore the event."
    override val deleteEventFailed = "Unable to delete the event."
    override val selectedDateUnavailableError = "Selected date is not available."
    override val selectedDateInPastError = "Selected date has already passed."
    override val notSelected = "Not selected"
    override fun atTime(time: String) = "at $time"
    override val enableNotificationsTitle = "Stay in the loop"
    override val enableNotificationsBody =
        "Enable browser notifications to get updates about new events and chat activity."
    override val allowNotificationsAction = "Allow notifications"
    override val notNowAction = "Not now"
    override val searchPlaceholder = "Search events, organizers, locations..."
    override val myTickets = "My Tickets"
    override val tapToViewTicket = "Tap to view ticket"
    override val favoriteEvents = "Favorites"
    override val eventsYouSaved = "Events you saved"
    override val recommendedForYou = "Recommended for You"
    override val curatedEvents = "Curated events based on your interests"
    override val recommendations = "Recommendations"
    override val upcomingEvents = "Upcoming Events"
    override val searchResults = "Search Results"
    override val noResults = "No results found"
    override val noAvailableEvents = "No available events"
    override val createEvent = "Create schedule"
    override val menu = "Menu"
    override val home = "Home"
    override val explore = "Explore"
    override val tickets = "Tickets"
    override val profile = "Profile"
    override val upcomingPaidTicketsTitle = "Upcoming paid tickets"
    override val otherTicketsTitle = "Other tickets"
    override val offlineTicketsNotice = "Showing saved tickets. Some information may be outdated."
    override val ticketsEmptyMessage = "You don't have any tickets yet."
    override val ticketDetailsTitle = "Ticket details"
    override val ticketNumberLabel = "Ticket number"
    override val ticketStatusActive = "Active"
    override val ticketStatusCancelled = "Cancelled"
    override val ticketStatusRefunded = "Refunded"
    override val ticketStatusUsed = "Used"
    override val ticketHolderLabel = "Ticket holder"
    override val cancelTicketAction = "Cancel ticket"
    override val ticketCancellationConfirmTitle = "Cancel ticket?"
    override val ticketCancellationConfirmMessage = "This will refund your seat and free it for another attendee."
    override val ticketCancellationSuccess = "Ticket cancelled"
    override val ticketCancellationFailure = "Couldn't cancel the ticket"
    override val ticketLoadError = "Couldn't load ticket"
    override val refresh = "Refresh"
    override val settings = "Settings"
    override val createEventTitle = "Create Event"
    override val eventTitle = "Event Title"
    override val eventTitlePlaceholder = "Enter event name"
    override val eventDescription = "Description"
    override val eventDescriptionPlaceholder = "Describe your event..."
    override val aiGenerateDescription = "AI: generate description"
    override val aiFormatDescription = "AI: structure/finalize description"
    override val addMedia = "Add Photo/Video"
    override val mediaDesktopLabel = "For desktop (wide)"
    override val mediaMobileLabel = "For mobile (square)"
    override val mediaChooseFile = "Choose file"
    override val location = "Location"
    override val onlineEvent = "Online Event"
    override val onlineLink = "Online Link"
    override val onlineLinkPlaceholder = "https://example.com/meeting"
    override val onlineLinkNotice = "Link will be available after payment"
    override val placeName = "Place Name"
    override val address = "Address"
    override val ticketPrice = "Ticket Price"
    override val ticketPricePlaceholder = "25.00"
    override val dateAndTime = "Date and Time"
    override val recurringEvent = "Recurring Event"
    override val recurrenceType = "Recurrence Type"
    override val daysOfWeek = "Days of Week"
    override val daysOfMonth = "Days of Month"
    override val selectDaysOfWeek = "Select Days of Week"
    override val selectDaysOfMonth = "Select Days of Month"
    override val time = "Time (HH:MM)"
    override val hiddenInfo = "Hidden Information"
    override val hiddenInfoDescription = "Will be available to users after ticket purchase"
    override val hiddenInfoPlaceholder = "Information visible only after payment..."
    override val enableGroupChatLabel = "Create group chat"
    override val enableGroupChatDescription = "Everyone who books or buys a ticket joins a shared chat."
    override val groupChatLabel = "Group chat"
    override val groupChatSubtitle = "Chat for all participants"
    override val carpoolSettings = "Carpool Settings"
    override val enableCarpool = "Enable Carpool"
    override val contactInfoSettings = "Contact Information Settings"
    override val requireContactInfo = "Collect contact information"
    override val requireContactInfoDescription = "Require clients to provide phone and additional information when booking"
    override val freeCarpool = "Free Carpool"
    override val carpoolPaymentPerPerson = "Payment per Passenger"
    override fun carpoolPaymentLabel(symbol: String) = "Payment per person ($symbol)"
    override val carpoolPaymentPlaceholder = "10.00"
    override val carpoolDescription = "Users can indicate they have a car and specify how many passengers they can transport"
    override val carpoolPaymentHint = "Set how much passengers should pay for the ride"
    override val selectDate = "Select Date"
    override val back = "Back"
    override val create = "Create"
    override val currency = "Currency"
    override val selectCurrency = "Select Currency"
    override val category = "Category"
    override val selectCategory = "Select Category"
    override val tags = "Tags"
    override val addTag = "Add Tag"
    override val maxCapacity = "Maximum Capacity"
    override val maxCapacityPlaceholder = "50"
    override val duration = "Duration"
    override val durationMinutes = "Duration (minutes)"
    override fun formatDuration(minutes: Int): String {
        if (minutes <= 0) return ""
        val days = minutes / (24 * 60)
        val hours = (minutes % (24 * 60)) / 60
        val mins = minutes % 60

        return when {
            days >= 7 -> {
                val weeks = days / 7
                val remainingDays = days % 7
                if (remainingDays > 0) "$weeks week${if (weeks > 1) "s" else ""} $remainingDays day${if (remainingDays > 1) "s" else ""}"
                else "$weeks week${if (weeks > 1) "s" else ""}"
            }
            days > 0 -> {
                if (hours > 0) "$days day${if (days > 1) "s" else ""} $hours h"
                else "$days day${if (days > 1) "s" else ""}"
            }
            hours > 0 -> {
                if (mins > 0) "$hours h $mins min"
                else "$hours h"
            }
            else -> "$mins min"
        }
    }
    override val locationCountry = "Country"
    override val selectOnMap = "Select on Map"
    override val locationSearchPlaceholder = "Enter address or venue name"
    override val onlineLinkHidden = "Link will be visible only after payment"
    override val timeZone = "Time Zone"
    override fun timeZoneValue(timeZoneId: String) = "Time zone: $timeZoneId"
    override val selectTimeZone = "Select Time Zone"
    override val localTimeZone = "Local Time Zone"
    override val mediaFilesAdded = "Files added"
    override val free = "Free"
    override val priceForFreeEvent = "0 - for free event"
    override val additionalOptions = "Additional Options"
    override val ageRestriction = "Age Restriction"
    override val languageEvent = "Event Language"
    override val contactInfo = "Contact Information"
    override val website = "Website"
    override val phone = "Phone"
    override val email = "Email"
    override val comment = "Comment"
    override val phoneRequired = "Phone is required"
    override val city = "City"
    override val search = "Search"
    override val year = "Year"
    override val month = "Month"
    override val day = "Day"
    override fun weekdayShortName(index: Int) = listOf("Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun")[index % 7]
    override fun weekdayName(index: Int) = listOf(
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday"
    )[index % 7]
    override fun monthNameFull(month: Int) = listOf(
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    )[(month - 1).mod(12)]
    override fun monthNameGenitive(month: Int) = monthNameFull(month)
    override val createEventWizard = "Create Event"
    override val step = "Step"
    override val of = "of"
    override val next = "Next"
    override val previous = "Previous"
    override val saveDraft = "Save Draft"
    override val editEvent = "Edit Event"
    override val step1BasicInfo = "Basic Information"
    override val step2Schedule = "Schedule"
    override val scheduleTypeLabel = "Schedule type"
    override val scheduleOneTimeDescription = "Single event on a chosen date"
    override val scheduleWeeklyDescription = "Repeats on selected week days"
    override val scheduleSlotDescription = "Calendar of bookable slots"
    override val scheduleOneTimeSetup = "One-time event setup"
    override val schedulePreviewTitle = "Preview"
    override fun schedulePreviewDate(date: String) = "Date: $date"
    override fun schedulePreviewTime(start: String, end: String) = "Time: $start - $end"
    override val step3Location = "Location"
    override val eventSetupTitle = "Event setup"
    override val eventTypeLabel = "Event type"
    override val oneTimeEvent = "One-time Event"
    override val eventSeries = "Event Series"
    override val weekly = "Weekly"
    override val monthly = "Monthly"
    override val slotBooking = "Slot Booking"
    override val slotLabel = "Slot"
    override val slotsLabel = "Slots"
    override val selectDayOfWeek = "Select Day of Week"
    override val selectDayOfMonth = "Select Day of Month"
    override val availableTimeRange = "Available Time Range"
    override val startTime = "Start Time"
    override val endTime = "End Time"
    override val endDateLabel = "End date (optional)"
    override val invalidEndDate = "End date must be on or after the start date"
    override val invalidEndTime = "End time must be after the start time"
    override val eventDateMustBeFuture = "Event date must be in the future"
    override val eventTimeMustBeFuture = "Event time must be after current time"
    override val slotSettings = "Slot Settings"
    override val minSlots = "Min. Slots"
    override val minSlotsPlaceholder = "1"
    override val slotDuration = "Duration (min)"
    override val slotDurationPlaceholder = "30"
    override val perDayTimeConfiguration = "Available hours for each day"
    override val driverCompensation = "Driver Compensation"
    override val fixedAmountPerPassenger = "Fixed Amount per Passenger"
    override val coordinateRide = "Coordinate Ride"
    override val participantsWithCar = "Participants with Car"
    override val needRide = "Need Ride"
    override val draft = "Draft"
    override val saved = "Saved"
    override val eventSaveErrorTitle = "Couldn't save event"
    override val eventSaveErrorMessage = "Something went wrong while saving your event. Please try again."
    override val deleteEventTitle = "Delete event?"
    override val deleteEventMessage = "This action cannot be undone. Do you want to continue?"
    override val eventDeletedMessage = "Event deleted"
    override val organizerLabel = "Organizer"
    override val online = "Online"
    override val offline = "Offline"
    override val eventDetailsTitle = "Event details"
    override val addToFavorites = "Add to favorites"
    override val removeFromFavorites = "Remove from favorites"
    override val ticketTierStandard = "Standard"
    override fun ticketsAvailable(count: Int) = "$count tickets available"
    override val viewTicket = "View ticket"
    override val bookingRequestFailed = "Couldn't book the ticket"
    override val contactSendFailed = "Couldn't submit contact info"
    override val slotLoadFailed = "Couldn't load slots"
    override val slotBookingFailed = "Couldn't book slots"
    override val ticketIssuanceFailed = "Couldn't issue tickets"
    override val unexpectedReservation = "Unexpected reservation for free event"
    override val sampleReviewerName = "Anna Petrova"
    override val sampleReviewTimeAgo = "2 days ago"
    override val selectVisitDate = "Select visit date"
    override fun availableDaysLabel(days: String) = "Available days: $days"
    override val previousMonth = "Previous month"
    override val nextMonth = "Next month"
    override fun slotSelectionMessage(date: String, time: String?) =
        if (time.isNullOrBlank()) "You selected: $date" else "You selected: $date at $time"
    override fun eventImageContentDescription(title: String, index: Int) = "$title - Image $index"
    override val dateTbd = "TBD"
    override val recurringWeeklyDescription = "This event runs every week on the selected days."
    override val recurringMonthlyDescription = "This event runs each month on the chosen weekdays."
    override val userCardTitle = "Organizer profile"
    override val followAction = "Follow"
    override val followingAction = "Following"
    override val followersCountLabel = "Followers"
    override val followingCountLabel = "Following"
    override val eventsCountLabel = "Events"
    override val organizerEventsTitle = "Upcoming events"
    override val archiveSectionTitle = "Archive"
    override val aboutOrganizerTitle = "About organizer"
    override val userEventsEmpty = "This organizer has no upcoming events yet."
    override val userArchiveEmpty = "No archived events."
    override val addShortcutTitle = "Add shortcut?"
    override fun addShortcutMessage(displayName: String) =
        "Add $displayName to your home screen for quick access to their events?"
    override val addShortcutConfirm = "Add shortcut"
    override val addShortcutDismiss = "Not now"
    override val dateLabel = "Date"
    override val participants = "Participants"
    override val spotsLeft = "spots left"
    override val ticketQuantityLabel = "Number of tickets"
    override val increaseQuantity = "Increase quantity"
    override val decreaseQuantity = "Decrease quantity"
    override val costLabel = "Cost of participation"
    override val serviceFee = "Service fee"
    override val totalAmount = "Total"
    override fun serviceFeePercent(percent: Int) = "Service fee ($percent%)"
    override val dressCode = "Dress code"
    override val dressCodePlaceholder = "Formal"
    override val description = "Description"
    override val reviews = "Reviews"
    override val allReviews = "All reviews"
    override val contactOrganizer = "Contact organizer"
    override val slotBookingsTitle = "Slot bookings"
    override val slotBookingsEmptyMessage = "No slots booked yet."
    override val showAllBookings = "All"
    override val showToday = "Today"
    override val showThisMonth = "This month"
    override val showSelectedDate = "Selected date"
    override val noBookingsForSelectedDate = "No bookings for this date."
    override val noTicketsForSelectedDate = "No tickets for this date."
    override fun totalCount(count: Int) = "Total: $count"
    override val cancelEventAction = "Cancel event"
    override val cancelEventDescription = "Stop ticket sales and mark the event as cancelled for all attendees."
    override val organizerActionsTitle = "Organizer tools"
    override val eventAlreadyCancelledNotice = "The event is already cancelled."
    override val eventCancelledTitle = "Event cancelled"
    override val eventCancelledSubtitle = "The organizer cancelled this event. Booking is no longer available."
    override val unpublishedBookingNotice = "Booking will be available once this event is published."
    override val cancellationReasonLabel = "Cancellation reason"
    override val cancellationReasonPlaceholder = "Describe why you are cancelling"
    override val cancellationReasonRequired = "Please provide a short reason."
    override val cancelSelectedSlotsAction = "Cancel selected slots"
    override val cancelSelectedSlotsDescription = "Attendees will no longer be able to reserve the selected slots."
    override val cancelSlotDayAction = "Cancel selected day"
    override val cancelSlotDayDescription = "All slots for the selected day will be blocked."
    override val selectedSlotsLabel = "Selected slots"
    override val selectedDayLabel = "Selected day"
    override val restoreEventAction = "Restore event"
    override val restoreEventDescription = "Re-open the event for attendees after a cancellation."
    override val restoreSelectedSlotsAction = "Restore selected slots"
    override val restoreSelectedSlotsDescription = "Allow attendees to book the selected slots again."
    override val restoreSlotDayAction = "Restore selected day"
    override val restoreSlotDayDescription = "Reopen all slots for the selected day."
    override val bookingStatusPending = "Pending"
    override val bookingStatusConfirmed = "Confirmed"
    override val bookingStatusCancelled = "Cancelled"
    override val bookingStatusCompleted = "Booked"
    override val bookingStatusNoShow = "No-show"
    override val viewDetails = "View details"
    override val hideDetails = "Hide details"
    override val openChat = "Open chat"
    override val clientNotesLabel = "Client comment"
    override val bookingDetailsTitle = "Booking details"
    override val slotBookedByLabel = "Booked by"
    override val slotAvailableLabel = "Available"
    override val statusLabel = "Status"
    // Stripe Connect
    override val connectTitle = "Direct Payments"
    override val connectStatusActive = "Active"
    override val connectStatusPending = "Pending"
    override val connectStatusPlatform = "Platform"
    override val connectStatusUnderReview = "Under Review"
    override val connectStatusSetupNeeded = "Setup Required"
    override val connectEnableDirectAction = "Enable Direct Payments"
    override val connectContinueOnboarding = "Continue Setup"
    override val connectOpenDashboard = "Open Stripe Dashboard"
    override val connectSwitchToPlatform = "Switch to Platform"
    override val connectPlatformFeeLabel = "Platform fee"
    override val connectDirectPaymentsEnabled = "Direct payments enabled"
    override val connectSwitchedToPlatform = "Switched to platform payments"
    override val connectOnboardingDescription = "Set up your Stripe account to receive payments directly"
    override val connectActiveDescription = "Payments go directly to your Stripe account"
    override val connectPlatformDescription = "Payments are processed through the platform"
    override val connectUnderReviewDescription = "Your account is being reviewed by Stripe"
    override fun connectPlatformFeeValue(percent: Int) = "$percent%"

    override val billingTitle = "Billing"
    override val currentBalanceLabel = "Current balance"
    override val openBillingAction = "Billing & payouts"
    override val withdrawFundsAction = "Withdraw funds"
    override val pendingPayoutsLabel = "Pending payouts"
    override val withdrawnTotalLabel = "Withdrawn"
    override val billingFilterWeek = "7 days"
    override val billingFilterMonth = "30 days"
    override val billingFilterQuarter = "90 days"
    override val grossSalesLabel = "Gross sales"
    override val feesLabel = "Fees"
    override val netRevenueLabel = "Net revenue"
    override val payoutRequestsTitle = "Withdrawal requests"
    override val payoutRequestsEmpty = "No withdrawal requests yet"
    override val payoutStatusPending = "Pending"
    override val payoutStatusProcessing = "Processing"
    override val payoutStatusPaid = "Paid"
    override val payoutStatusRejected = "Rejected"
    override val requisitesTitle = "Payout details"
    override val requisitesAccountLabel = "Account number"
    override val requisitesInnLabel = "INN"
    override val requisitesKppLabel = "KPP"
    override val requisitesBikLabel = "BIC"
    override val bankLabel = "Bank"
    override val soldTicketsTitle = "Sold tickets"
    override val soldTicketsEmpty = "No ticket sales in this period"
    override val withdrawConfirmTitle = "Withdraw funds?"
    override fun withdrawConfirmMessage(amount: String) =
        "You are about to request a payout for $amount."
    override val billingWithdrawSuccess = "Withdrawal request submitted"
    override val billingWithdrawFailed = "Couldn't submit withdrawal request"
    override val billingWithdrawUnavailable = "There is no balance available for withdrawal"
    override val payoutMethodEtransfer = "eTransfer (Canada)"
    override val payoutMethodWise = "Wise transfer"
    override val payoutDetailsTitle = "Payout details"
    override val payoutEmailLabel = "Recipient email"
    override val payoutWiseNameLabel = "Account holder name"
    override val payoutWiseAccountLabel = "Account number / IBAN"
    override val payoutWiseBankLabel = "Bank name or SWIFT"
    override val payoutWiseRoutingLabel = "Routing number"
    override val payoutWiseAccountTypeLabel = "Account type"
    override val payoutAccountTypeChecking = "Checking"
    override val payoutAccountTypeSavings = "Savings"
    override val payoutNoteLabel = "Withdrawal note (optional)"
    override fun soldTicketQuantity(quantity: Int, grossAmount: String) =
        "$quantity x $grossAmount"
    override fun soldTicketBuyerInfo(buyerName: String, soldAt: String) =
        "$buyerName - $soldAt"
    override fun soldTicketServiceFee(fee: String) = "- $fee"
    override fun shortMonthName(month: Int): String = when (month) {
        1 -> "Jan"
        2 -> "Feb"
        3 -> "Mar"
        4 -> "Apr"
        5 -> "May"
        6 -> "Jun"
        7 -> "Jul"
        8 -> "Aug"
        9 -> "Sep"
        10 -> "Oct"
        11 -> "Nov"
        12 -> "Dec"
        else -> ""
    }
    override val accountDetails = "Account details"
    override val interfaceLanguage = "Interface language"
    override val profileSavedMessage = "Profile updated"
    override val profileLogoutDescription = "Sign out of iJoin on this device."
    override val profileLoadError = "Couldn't load profile"
    override val logoutError = "Failed to log out. Please try again."
    override val profileDeletedMessage = "Account deleted"
    override val deleteAccountTitle = "Delete account"
    override val deleteAccountDescription = "This will deactivate your account, anonymize personal data, and remove your events from search."
    override val deleteAccountAction = "Delete account"
    override val deleteAccountConfirmMessage = "Are you sure? Please withdraw any remaining balance via a payout request before deleting."
    override val aiConsentSectionTitle = "AI Data Processing"
    override val aiConsentEnabled = "You have consented to share data with AI services (OpenAI, Google) for optional features like transcription and description generation."
    override val aiConsentDisabled = "AI data processing consent is not active. AI features are unavailable."
    override val aiConsentWithdrawButton = "Withdraw Consent"
    override val aiConsentEnableButton = "Enable AI Features"
    override val aiConsentWithdrawConfirmTitle = "Withdraw AI Consent?"
    override val aiConsentWithdrawConfirmMessage = "AI features (transcription, description generation, landing pages) will become unavailable. You can re-enable them at any time."
    override val aiConsentWithdrawnSuccess = "AI data processing consent withdrawn"
    override val aiConsentEnabledSuccess = "AI data processing consent granted"
    override val messagesTitle = "Messages"
    override val emptyChatList = "No conversations yet"
    override val emptyMessages = "No messages yet. Start the conversation!"
    override val typeMessage = "Message..."
    override val send = "Send"
    override val chatSearchPlaceholder = "Search users by name"
    override val chatSearchNoResults = "No users found"
    override val chatLoadError = "Couldn't load chat messages"
    override val chatSendError = "Couldn't send message"
    override val chatOpenError = "Couldn't open chat"
    override val chatStartError = "Couldn't start chat"
    override val chatSearchError = "Couldn't search users right now"
    override val paymentTitle = "Reservation Payment"
    override val paymentSubtitle = "Complete payment for your booking"
    override val paymentDescription = "Once the payment succeeds, your reservation updates automatically."
    override val paymentPreparing = "Preparing Stripe checkout..."
    override val paymentFetchingTickets = "Fetching your tickets..."
    override val paymentCompletedMessage =
        "Payment confirmed. If tickets didn't appear automatically, refresh the list below."
    override val paymentStripePopupHint =
        "Stripe opens in a pop-up window. If nothing appeared or you closed it, tap \"Restart payment\"."
    override val paymentRetryButton = "Restart payment"
    override val paymentRetryTicketsButton = "Fetch tickets again"
    override val paymentStartFailed = "Failed to start payment"
    override val paymentTicketContextMissing = "Couldn't determine booking for issuing tickets"
    override val paymentTicketsNotFound = "Tickets not found"
    override val paymentTicketsFetchFailed = "Unable to fetch tickets"
    override val paymentStripeOverlayTitle = "Stripe payment"
    override val paymentStripeOverlayDescription = "Enter your card details to finish the booking."
    override val paymentStripeOverlayPayButton = "Pay now"
    override val paymentStripeOverlayPayButtonLoading = "Processing..."
    override val paymentStripeOverlayCancelButton = "Cancel"
    override val paymentStripeOverlayOpenError = "Unable to open the Stripe checkout."
    override val paymentStripeOverlayCancelMessage = "Payment cancelled"
    override val paymentStripeOverlayInitError = "Unable to initialize Stripe."
    override val paymentStripeOverlayPaymentFailed = "Payment failed"
    override val paymentStripeOverlayUnexpectedStatusPrefix = "Unexpected status: "
    override val paymentStripeOverlayProcessingFailed = "Failed to process payment"
    override val errorUserNotAuthenticated = "Please sign in to continue."
    override val errorAccessDenied = "You don't have permission to perform this action."
    override val errorForbiddenFollowingList = "You can only view your own following list."
    override val errorDataUrlRequired = "Image data (dataUrl) is required."
    override val errorMediaStoreFailed = "Failed to store media. Please try again."
    override val errorAmountMustBePositive = "Amount should be greater than zero."
    override val errorAmountExceedsBalance = "Requested amount exceeds available balance."
    override val errorPayoutEmailRequired = "Email is required for eTransfer payouts."
    override val errorPayoutWiseInfoRequired = "Full name, routing number and account number are required for Wise payouts."
    override val errorPayoutAccountType = "Unsupported account type. Use checking or savings."
    override val errorUnsupportedPayoutMethod = "Unsupported payout method."
    override val errorEventNotCancelled = "Event is not cancelled."
    override val errorChatWithSelf = "You can't start a chat with yourself."
    override val errorChatMessageEmpty = "Message cannot be empty."
    override val errorEventOrganizerRequired = "Event ID and organizer are required."
    override val errorEventUnavailable = "Event is no longer available."
    override val errorEventFinished = "Event has already finished."
    override val errorOrganizerNotProvider = "Organizer is not a service provider."
    override val errorServiceProviderInactive = "Service provider is not active."
    override val errorSlotsNotFound = "Some time slots were not found."
    override val errorSlotsMustSameEvent = "All time slots must belong to the same event."
    override val errorSlotsMustSameOrganizer = "All time slots must belong to the event's organizer."
    override val errorSlotsUnavailable = "One or more time slots are not available."
    override val errorSlotsInPast = "Cannot book time slots that are in the past."
    override val errorSlotsMustBeConsecutive = "Time slots must be consecutive."
    override val errorEventIdRequired = "Event ID is required."
    override val errorQuantityAtLeastOne = "Quantity must be at least 1."
    override val errorPaidReservationRequired = "This event requires a paid reservation."
    override val errorEventOrganizerInvalid = "Event organizer is not valid."
    override val errorEventOrganizerMissing = "Event organizer is not set."
    override val errorOrganizerCannotAccept = "Organizer is not able to accept bookings."
    override val errorOccurrenceRequired = "Occurrence date is required."
    override val errorOccurrencePassed = "Selected occurrence has already passed."
    override val errorTicketsNotEnough = "Not enough tickets available for this event."
    override val errorBookingOtherUser = "Booking belongs to another user."
    override val errorBookingNotAwaitingPayment = "Booking is not awaiting payment."
    override val errorBookingCancelled = "Booking is already cancelled."
    override val errorBookingNotActive = "Booking is no longer active."
    override val errorBookingIssuedTickets = "Booking already has issued tickets."
    override val errorEventRequiresPaymentFlow = "This event requires payment. Complete checkout to finish booking."
    override val errorReservationQuantityExceeded = "Requested quantity exceeds reservation."
    override val errorTicketAlreadyValidated = "Ticket already validated."
    override val errorTicketInactive = "Ticket is not active."
    override val errorTicketAlreadyCancelled = "Ticket already cancelled."
    override val errorTicketUsed = "Used tickets cannot be cancelled."
    override val errorOccurrencesRequired = "Occurrences are required."
    override val errorRequestRequired = "Request payload is required."
    override val errorBookingEventMismatch = "Booking does not belong to the provided event."
    override val errorBookingProcessed = "Booking is already processed."
    override val errorOverrideAmountAdminOnly = "Override amount is allowed only for administrators."
    override val errorOverrideAmountPositive = "Override amount must be positive."
    override val errorUnableDetermineTicketPrice = "Unable to determine ticket price."
    override val errorEmailAlreadyRegistered = "Email already registered."
    override val errorInvalidCredentials = "Invalid email or password."
    override val errorAccountInactive = "Account is inactive."
    override val errorAccountDeleted = "Account has been deleted."
    override val errorAccountBalanceNotZero = "Please withdraw the remaining balance before deleting your account."
    override val errorInvalidRefreshToken = "Invalid refresh token."
    override val errorAvatarDataUrlRequired = "Avatar data must be provided as a data URL."
    override val errorAvatarMustBeImage = "Avatar must be an image."
    override val errorAvatarInvalidDataUrl = "Avatar data URL is invalid."
    override val errorStripeSignatureInvalid = "Invalid Stripe signature."
    override val errorMediaUnsupportedFormat = "Unsupported image format."
    override val errorReservationExpired = "Reservation expired. Please start a new booking."
    override val login = "Login"
    override val register = "Register"
    override val continueWithGoogle = "Continue with Google"
    override val continueWithApple = "Continue with Apple"
    override val logout = "Logout"
    override val password = "Password"
    override val username = "Username"
    override val firstName = "First Name"
    override val lastName = "Last Name"
    override val confirmPassword = "Confirm Password"
    override val alreadyHaveAccount = "Already have an account?"
    override val dontHaveAccount = "Don't have an account?"
    override val loginHere = "Login here"
    override val registerHere = "Register here"
    override val welcomeBack = "Welcome back!"
    override val createAccount = "Create Account"
    override val loginError = "Login failed. Please check your credentials."
    override val registerError = "Registration failed. Please try again."
    override val passwordsDontMatch = "Passwords don't match"
    override val fillAllFields = "Please fill in all required fields"
    override val invalidEmail = "Please enter a valid email address"
    override val forgotPassword = "Forgot password?"
    override val passwordResetTitle = "Reset password"
    override val passwordResetDescription = "Enter your email address to receive reset instructions."
    override val passwordResetSetNewPassword = "Set a new password"
    override val sendResetLink = "Send reset link"
    override fun passwordResetEmailSent(email: String) =
        "If an account exists for $email, we sent a reset link."
    override val passwordResetTokenLabel = "Reset token"
    override val passwordResetTokenDescription =
        "Paste the code from your email or open the link on this device."
    override val newPassword = "New password"
    override val resetPasswordAction = "Update password"
    override val passwordResetSuccess = "Password updated! You can sign in with the new password."
    override val backToLogin = "Back to login"
    override val invalidPhone = "Please enter a valid phone number"
    override val provideAnyContact = "Enter phone or email"
    override val checkContacts = "Please check contacts format"
    override val contactSubmitting = "Saving..."
    override val contactSubmitted = "Request sent"
    override val book = "Book"
    override val bookFree = "Book for Free"
    override val bookingSuccess = "Successfully booked!"
    override val bookingFailed = "Booking failed"
    override fun bookForPrice(price: String) = "Book for $price"
    override val prev = "Previous"
    override val showAll = "Show all"
    override val collapse = "Collapse"
    override val missingTitle = "Enter event title"
    override val missingDescription = "Enter event description"
    override val missingScheduleType = "Select schedule type"
    override val missingDate = "Select event date"
    override val missingTime = "Select event time"
    override val missingWeeklyDays = "Select one or more weekdays"
    override val missingWeeklyTime = "Select time for weekly event"
    override val missingSlotDays = "Select slot days of week"
    override val missingSlotStart = "Select slot start time"
    override val missingSlotEnd = "Select slot end time"
    override val missingLocation = "Please specify the event location"
    override val optional = "Optional"

    // Organizer bookings section
    override val bookingsTitle = "Bookings"
    override val unconfirmedRequestsTitle = "Unconfirmed requests"
    override val detailsButton = "Details"
    override val hideDetailsBooking = "Hide"
    override val noBookings = "No bookings yet"
    override val noUnconfirmedRequests = "No unconfirmed requests"
    override val ticketInfoLabel = "Ticket"
    override val contactInfoLabel = "Contact information"
    override val paymentInfoLabel = "Payment"
    override val loadingPayment = "Loading..."
    override val clientLabel = "Client"
    override val paymentAmount = "Amount"
    override val paymentStatus = "Status"
    override val paymentDate = "Date"

    // App Store Banner
    override val appStoreBannerTitle = "Get the app"
    override val appStoreBannerMessage = "Download our app for the best experience"
    override val downloadOnAppStore = "Download on the App Store"
    override val getItOnGooglePlay = "Get it on Google Play"
    override val downloadAppLinks = "Download our app"
    override val appStoreUnavailableMessage = "Sorry, the app is being published to the store and will be available soon."

    // App Update
    override val updateAvailable = "Update Available"
    override val updateRequired = "Update Required"
    override val updateAvailableMessage = "A new version of iJoin is available. Update now for the latest features and improvements."
    override val updateRequiredMessage = "Please update iJoin to continue using the app. This version is no longer supported."
    override val updateNow = "Update Now"
    override val updateLater = "Later"
    override val newVersion = "New version"
    override val currentVersion = "Current version"
    override val whatsNew = "What's new"

    // AI Landing
    override val landingModeClassic = "Classic"
    override val landingModeAi = "AI Landing Page"
    override val landingModeTitle = "Landing Page Type"
    override val landingDescriptionLabel = "Landing Description"
    override val landingDescriptionPlaceholder = "Describe your event for the AI to generate a beautiful landing page..."
    override val recordVoice = "Record voice"
    override val stopRecording = "Stop recording"
    override val transcribing = "Transcribing..."
    override val recordingTooShort = "Recording is too short (minimum 3 seconds)"
    override val recordingTooLong = "Recording is too long (maximum 5 minutes)"
    override val microphoneAccessDenied = "Microphone access denied"
    override fun recordingDuration(seconds: Int) = "${seconds}s"
    override val enableLandingPageLabel = "Use landing page"
    override val enableLandingPageDescription = ""

    // Legal Documents
    override val termsOfService = "Terms of Service"
    override val privacyPolicy = "Privacy Policy"
    override val refundPolicy = "Refund & Cancellation Policy"
    override val organizerTerms = "Organizer Terms"
    override val aiDataConsent = "AI Data Processing Consent"
    override val aiConsentTitle = "AI Features Use Third-Party Services"
    override val aiConsentDescription = "Some features in this app use artificial intelligence services provided by OpenAI and Google. When you use these features, certain content you provide is sent to these services for processing."
    override val aiConsentDataSent = "Data that may be sent:"
    override val aiConsentDataSentAudio = "Audio recordings (for transcription)"
    override val aiConsentDataSentDescription = "Event descriptions (for text improvement)"
    override val aiConsentDataSentLanding = "Landing page details (for content generation)"
    override val aiConsentProviders = "Data is processed by OpenAI (OpenAI, L.L.C.) and Google (Google LLC). Your personal account data (name, email) is not sent unless included in the content you submit. You can review the full AI Data Processing Consent for details."
    override val aiConsentOptional = "AI features are optional. You can use the app without them."
    override val aiConsentAccept = "I Agree"
    override val aiConsentDecline = "Not Now"
    override val iAgreeToThe = "I agree to the following:"
    override val iAgreeToTerms = "I agree to the Terms of Service, Privacy Policy, and Refund Policy"
    override val iAgreeToOrganizerTerms = "I agree to the Organizer Terms"
    override val pleaseAcceptTerms = "Please accept the terms to continue"
    override val pleaseAcceptOrganizerTerms = "Please accept the Organizer Terms to publish events"
    override val viewDocument = "View"
    override val legalDocumentLoading = "Loading document..."
    override val legalDocumentLoadError = "Failed to load document"
    override val newUserGoogleNote = "If you're new, please accept the terms before signing in with Google:"
    override val legalDocumentsUpdated = "Terms Updated"
    override val legalDocumentsUpdatedDescription = "We've updated our terms. Please review and accept the updated documents to continue using the app."
    override val iAcceptUpdatedTerms = "I accept the updated terms"
    override val continueButton = "Continue"
}
